/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from './transformer';
import EmbedUser from './job/embedUser';
import Company from './company';
import Picture from './common/picture';

export default class AccountTransformer extends Transformer {
  /**
   * Method used to transform a fetched account
   *
   * @param account The fetched account
   *
   * @returns {Object} The transformed account
   */
  static fetch(response) {
    return {
      id: response.id,
      tracking: response.tracking ? response.tracking : null,
      phone: response.phone,
      jobPosition: response.job_position,
      created: response.created,
      email: response.email,
      firstName: response.firstname,
      lastName: response.lastname,
      mainPicture: response.main_picture ? Picture.fetch(response.main_picture) : null,
      links: response.links,
      company: response.company ? Company.fetch(response.company) : null,
      companies: Array.isArray(response.companies) ? response.companies : [],
      operationalManager: response.operational_manager ? EmbedUser.fetch(response.operational_manager) : null,
      salesManager: response.sales_manager ? EmbedUser.fetch(response.sales_manager) : null,
      kpi: response.kpi,
      customer: response.customer,
      admin: response.admin,
      student: response.student,
      canValidateOrder: response.can_validate_order,
      paymentStatus: response.customer_payment_status,
      orderBlocked: response.customer_order_blocked,
      arcadeLinks: response.arcade_links,
      newsletterSubscribed: response.newsletter_subscribed,
    };
  }

  static create(userInfo, userCompany) {
    return {
      email: userInfo.email,
      countryCode: 'FR',
      firstname: userInfo.firstname,
      lastname: userInfo.lastname,
      phone: userInfo.tel,
      origin: userInfo.origin,
      jobPosition: userInfo.poste,
      plainPassword: userInfo.password,
      // socialConnect: [userInfo.authMethod],
      main_picture: userInfo.avatarUrl,
      customer: {
        name: userCompany.name,
        companySize: userCompany.size,
        businessSector: userCompany.activity,
        description: userCompany.description,
        logo: userCompany.avatarUrl,
        currency: 'EUR',
      },
    };
  }
}
